/* This file is autogenerated, see readme.md for instructions */
import ChevronDownFillSvgIcon from '@bloomreach/banana-theme/icons/chevron-down-fill.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ChevronDownFillIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ChevronDownFillSvgIcon />
    </Icon>
  );
});

ChevronDownFillIcon.displayName = 'ChevronDownFillIcon';

export default ChevronDownFillIcon;
